var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_199",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_199",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABDRJREFUeAHtW0toE1EU7aRJGgW1aZAKfoifRSBpQpq6qgjuRAXRjYpadOGuBdHiVjd+FuIq4MKFoBXrTtCNgrhSK6RNLSlEihjRhRVTPxsTYxPPHfKGZ5yUZPJe20ffQPpe3ufknHPvZCbMbVubPrQD2gHtwAp2wJCs3ZNIJPbgM+KGYQTL5XJDn+dyuSo4ctiXHh8ff462hJeUoyFCTj45Go1GPB7PHQiPO9nP9sCIdKlUGpiamsqwMZGtFAMikchmn89HhNcyshDyg/UbaWHcOm7dz0KhEMlkMh+5MSFdtxCUGpCOjo5bGDLFQ/gNRDCJCL6vWbbgW2TQVmTQIIw4R1hVzL0LbnIwKTwDgsFgZyAQmANxA+Lf4by/7oCXtQXfB8OA2g6sSj6f78rlct+tSQEd4Rng9/sTJJ64EfH29vabAngSlkHYMOCZCDyG4WIdge16gVi1UMKxhWcAzxhBO4pT4A0/1mwfp0AM2T/a7L5G10s1YH5+/sPExES2UTJ263p7ezthgt2UkDHTgFAoFMC56hGBiKhbly8Q7wqHwxtawSUMtp+wW8VjWAhOKZvN5o2+vr67GDzBJlZYO2LgVrUMZ4VfDlUwki6tbiYe/Rcg/VgF4gI4HoDuftLOfwmm8MPjmgDwZQ+BrKfvpX4iyhtgEY/FYhvdbvdBDLT6xTgGU18TcE9Pzzbc2u6D6eVisfhIxn29JaCJjq0BED8KoruawKm39A9+GG2C2Fmv1/sEmDtoIX4onUazs96mxRyvd4E1oyaAyFuI/0Y4ED/G4fF9bnjxu7YZgLQdxvX2Cuh4nVKC4ArEf8H+CmGkUqmTuN84i/uNyvT09JxTXNH7bA2gD5FBkm48RAtoFa/eKdAqrjL7tQHKhEoSUZ0BkoxVBlZngDKhkkRUZ4AkY5WB1RmgTKgkEdUZIMlYZWB1BigTKklEdQZIMlYZWJ0ByoRKElGdAZKMVQZWZ4AyoZJEVGeAJGOVgeUzIIZ6nKgyzJ0RdeHROD30TbDtVCJjPrtjAyiUyKKyazCdTgutx2P4S9UiuKdQb0T1D908Bz4DzHE81Axh4VMYc4lfqHDfCy2j0HQbGv4RT5p4Ax7g/QjVzcAEGr8Yj8cHaJHKB1L+MvgfIQ2QRmX3SWT4PXpPh2UAJj/TI2xMUumI+fgaj7KTeEy+xVyp4B8EcDdonyfq0DeD0rgwNA4hwF+ZHMsANoBz/xUWX62+X4NqjuNsTrUWATwDsawC7sLk5ORMrYb/DKAFqMpOovlEfew/RK2ChxuB3E+8kdUvUfTx0E6DdRXA4t9Y8ItbtBrizSIpzDX1zw4cxpJ1q5E3/2cBJArQUOTIrMK8Wf1CFSKzeHVXB2xLYjBnlb9yICp1fdDgsyE8S4WSh+HOMaRJqyVxNvjLdwiXxRK031++DDUz7YB2QDuwCA78BQgnHfsMS4e1AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.502ed8547379c5b80cfdc6b3423b8265.svg";
export { ForwardRef as ReactComponent };